// JavaScript Document
//components/configuration/standard/forms/beacon.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

//import TextArea from '@material-ui/core/TextareaAutosize';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({

	detailsVerticalCenter: {
		display: "flex",
		alignItems:"center",
		justifyContent:"space-around",
		flexGrow: 1,
		flexDirection: "column",
		flexWrap: "wrap",
	},
}));

export default function ImagePicker(props) {
  	const classes = useStyles();
	//inherited variables
  	const {items, onChange, id, label, name, value, width, height} = props;
	const [myValue, setMyValue] = React.useState(0);
	const [size, setSize] = React.useState(['100%', 125]);
	//local state varialbes user will change
	//Local constant for maximum value
	
	//Refresh UI on props change
	React.useEffect(() => {
		setMyValue(value);
		if(width && height){
			setSize([width, height]);
		}
	}, [height, width, value]);
	
	
  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<TextField
			id={id}
			label={label}
			name={name}
			value={myValue}
			onChange={onChange}
			select	
			fullWidth
		>
			{items.map((pic) => (
			<MenuItem value={pic.id} className={classes.detailsVerticalCenter}>
				<Typography>{pic.name}</Typography>
				<div
					style={{
						backgroundImage:'url("http://forteltraffic.com/'+encodeURI(pic.path)+'")', 
	  					backgroundSize:'contain', 
	  					backgroundRepeat:'no-repeat', 
	  					backgroundPosition:'center',
						width: size[0],
						height: size[1]
					}} />
			</MenuItem>
			))}
		</TextField>
  );
}
